<template>
  <form
    class="needs-validation"
    :class="formClass"
    style="max-width: 500px"
    novalidate
    @submit.prevent="submitHandler"
  >
    <div v-for="(option, index) in options" :key="index" class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="force-majeurs"
        :id="'option_' + index"
        v-model="forceMajeur"
        :value="option"
      />
      <label
        class="form-check-label"
        :for="'option_' + index"
        v-text="option.name"
      />
    </div>

    <template v-if="Object.keys(forceMajeur).length !== 0">
      <p class="fw-bold mt-4">Введіть особисті дані для рахунку та акту:</p>

      <div class="mb-2">
        <label for="zamovnyk" class="form-label">
          Замовник:
        </label>
        <input
          type="text"
          class="form-control"
          id="zamovnyk"
          required
          v-model="userData.zamovnyk"
        />
        <div class="invalid-feedback">
          Обов'язкове поле
        </div>
      </div>

      <div class="mb-2">
        <label for="posada_predstavnyka" class="form-label">
          Посада представника замовника:
        </label>
        <input
          type="text"
          class="form-control"
          id="posada_predstavnyka"
          required
          v-model="userData.posada_predstavnyka"
        />
      </div>

      <div class="mb-2">
        <label for="pib_predstavnyka" class="form-label">
          П.І.Б пдерставника (або фіз. особи):
        </label>
        <input
          type="text"
          class="form-control"
          id="pib_predstavnyka"
          required
          v-model="userData.pib_predstavnyka"
        />
        <div class="invalid-feedback">
          Обов'язкове поле
        </div>
      </div>

      <div class="mb-2">
        <label for="edrpou" class="form-label">
          ЄДРПОУ/ІПН:
        </label>
        <input
          type="text"
          class="form-control"
          id="edrpou"
          required
          v-model="userData.edrpou"
        />
      </div>

      <div class="mb-2">
        <label for="yur_adresa" class="form-label">
          Юридична адреса:
        </label>
        <input
          type="text"
          class="form-control"
          id="yur_adresa"
          required
          v-model="userData.yur_adresa"
        />
      </div>

      <div class="mb-2">
        <label for="status_platnika_podatku" class="form-label">
          Статус платника податку:<br />
          <span class="italic"
            >Зазначити повне найменування статусу платника податку відповідно до
            законодавства України</span
          >
        </label>
        <input
          type="text"
          class="form-control"
          id="status_platnika_podatku"
          required
          v-model="userData.status_platnika_podatku"
        />
      </div>

      <div class="mb-2">
        <label for="status_platnika_podatku" class="form-label">
          Поточний рахунок (IBAN):
        </label>
        <input
          type="text"
          class="form-control"
          id="status_platnika_podatku"
          required
          v-model="userData.iban"
        />
      </div>
    </template>

    <div class="form-check mt-4">
      <input
        class="form-check-input"
        type="checkbox"
        v-model="urgent"
        :disabled="!forceMajeur.urgentAvalibility || msb"
        id="urgent"
      />
      <label class="form-check-label" for="urgent">
        Терміново
      </label>
    </div>

    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        v-model="msb"
        :disabled="!forceMajeur.msbAvalibility"
        id="msb"
      />
      <label class="form-check-label" for="msb">
        Для суб’єктів малого підприємництва
      </label>
    </div>

    <div class="my-3 fw-bold">
      <p>Вартість послуги, грн.: {{ price }}</p>
      <p>Сума ПДВ, грн.: {{ pdv }}</p>
      <p>Всього із ПДВ, грн.: {{ fullPrice }}</p>
    </div>

    <input
      type="submit"
      value="Завантажити"
      class="btn btn-primary my-3"
      :disabled="disableSubmit"
    />
  </form>
</template>

<script>
export default {
  name: 'ForceMajeurs',
};
</script>

<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  template: {
    type: [Number, String],
    required: true,
  },
});

const formClass = ref('');

const forceMajeur = ref({});
const urgent = ref(false);
const msb = ref(false);
const userData = ref({
  zamovnyk: '',
  posada_predstavnyka: '',
  pib_predstavnyka: '',
  edrpou: '',
  yur_adresa: '',
  status_platnika_podatku: '',
  iban: '',
});

const disableSubmit = computed(() => {
  if (
    Object.keys(forceMajeur.value).length !== 0 &&
    !!userData.value.zamovnyk &&
    !!userData.value.pib_predstavnyka
  ) {
    return false;
  }

  return true;
});

watch(forceMajeur, () => {
  urgent.value = false;
  msb.value = false;
});

watch(msb, newVal => {
  if (newVal) {
    urgent.value = false;
  }
});

const price = computed(() =>
  urgent.value ? forceMajeur.value.price * 2 : forceMajeur.value.price
);
const pdv = computed(
  () => price.value && Number(+price.value * 0.2).toFixed(2)
);
const fullPrice = computed(
  () => price.value && Number(+price.value + +pdv.value).toFixed(2)
);

const submitHandler = () => {
  formClass.value = 'was-validated';

  fetch(window.rest.url + 'force-majeurs/submit', {
    method: 'POST',
    body: JSON.stringify({
      serviceData: {
        name: forceMajeur.value.name,
        nameRozgl: forceMajeur.value.nameRozgl,
        price: price.value,
        pdv: pdv.value,
        fullPrice: fullPrice.value,
        urgent: urgent.value,
        msb: msb.value,
      },
      userData: userData.value,
      templateId: props.template,
    }),
  })
    .then(res => res.json())
    .then(data => {
      window.open(data.downloadLink, '_blank');
    });
};
</script>
